import {createStore, withProps} from '@ngneat/elf';
import {withRequestsStatus} from '@ngneat/elf-requests';

import {ClientDetails} from '@store/clients/details/client-details.model';

export const clientDetailsStore = createStore(
  {name: 'client-details'},
  withProps<Partial<ClientDetails>>({}),
  withRequestsStatus(),
);